import { render, staticRenderFns } from "./pushMaterialModal.vue?vue&type=template&id=6b79bf58&scoped=true"
import script from "./pushMaterialModal.vue?vue&type=script&lang=js"
export * from "./pushMaterialModal.vue?vue&type=script&lang=js"
import style0 from "./pushMaterialModal.vue?vue&type=style&index=0&id=6b79bf58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b79bf58",
  null
  
)

export default component.exports